export function openFetchRequestInterceptor(ctx) {
  ctx.request = fillPath(ctx.request, ctx.options.path);
}
export function createOpenFetch(options) {
  return (url, opts) => globalThis.$fetch(
    fillPath(url, opts?.path),
    typeof options === "function" ? options(opts) : {
      ...options,
      ...opts
    }
  );
}
export function fillPath(path, params = {}) {
  for (const [k, v] of Object.entries(params))
    path = path.replace(`{${k}}`, encodeURIComponent(String(v)));
  return path;
}
